<template>
  <div>
    <div style="font-size: 16px; font-weight: 700; margin-bottom: 4px;">
      {{ $t('leadWeekly.intro.welcome', { name: user.name || $t('leadWeekly.user.defaultName') }) }}
    </div>
    <div>{{ $t('leadWeekly.intro.report') }}</div>

    <div style="margin: 24px 0 0 0; display: flex; flex-direction: column; gap: 12px;">
      <lpe-report-lead-row-count :object="pending" name="PENDING" span-bg="#E97018" />
      <lpe-report-lead-row-count :object="processing" name="PROCESSING" />
      <a
        href="https://app-v2.gtrsuite.com/network/leads/tabs/list"
        target="_blank"
        style="background: #53B027; border-radius: 30px; padding: 10px 15px; text-align: center; margin: 20px auto; text-decoration: none; color: white; font-weight: 600;"
      >
        {{ $t('leadWeekly.button.myLeads') }}
      </a>
    </div>
  </div>
</template>

<script>
import LpeReportLeadRowCount from '@/components/Lpe/Report/LeadRowCount.vue'

export default {
  name: 'LpeReportIntro',
  props: {
    pending: {
      type: Object,
      required: false,
      default: () => {},
    },
    processing: {
      type: Object,
      required: false,
      default: () => {},
    },
    user: {
      type: Object,
      required: true,
    },
  },
  components: {
    LpeReportLeadRowCount,
  },
}
</script>
